// gsap
import { gsap } from "gsap";

// hamburger constants
const hamburger = document.getElementById("hamburger");
const hamburgerTimeline = gsap.timeline({ paused: true });
// nav constants
const navBackground = document.querySelector(".nav-background");
const nav = document.getElementById("nav");
const navItems = nav.querySelectorAll("li");

// menu timeline
const navTimeline = gsap.timeline({
  paused: true,
});
navTimeline.to(navBackground, {
  duration: 1,
  right: "0",
  height: "300%",
  borderRadius: "0",
  ease: "Power4.easeOut",
  transformOrigin: "top right",
});
navTimeline.to(nav, {
  duration: 0.6,
  delay: -1.2,
  autoAlpha: 1,
  visibility: "visible",
  ease: "power4.easeOut",
});
navTimeline.to(navItems, {
  duration: 0.6,
  delay: -1,
  stagger: 0.05,
  right: "0",
  autoAlpha: 1,
  visibility: "visible",
  ease: "power4.easeOut",
});
navTimeline.to(hamburger, {
  delay: -1.2,
  duration: 0.2,
  backgroundColor: "#ffffff",
  ease: "power4.easeOut",
});

// open nav
function openNav() {
  // add no-scroll class to html
  document.documentElement.classList.add("no-scroll");
  nav.classList.add("open");
  navTimeline.play().timeScale(1);
}

// close nav
function closeNav() {
  // remove no-scroll class to html
  document.documentElement.classList.remove("no-scroll");
  nav.classList.remove("open");
  navTimeline.play().timeScale(-2);
}

// hamburger click event
hamburger.addEventListener("click", function () {
  // Get the aria-expanded attribute and check if the value is "false"
  const isOpen = hamburger.getAttribute("aria-expanded") === "false";

  // Change the aria-expanded value accordingly
  hamburger.setAttribute("aria-expanded", isOpen);

  // toggle nav
  if (isOpen) {
    openNav();
  } else {
    closeNav();
  }
});

// close nav on escape
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    closeNav();

    // reset hamburger
    hamburger.setAttribute("aria-expanded", false);
  }
});
